import { WebApiService } from '../../plugins/webApiService'
import { Events } from '../../plugins/events'
import { SendRequestModel } from '../../plugins/models/SendRequestModel'
import CustomerCreateRequest from '../../customers/i-service/model/request/CustomerCreateRequest';
import CustomerEditRequest from '../../customers/i-service/model/request/CustomerEditRequest';
import CustomerEditContactRequest from '../../customers/i-service/model/request/CustomerEditContactRequest';
import CustomerSearchRequest from '../../customers/i-service/model/request/CustomerSearchRequest';
import CustomerContactRequest from '../../customers/i-service/model/request/CustomerContactRequest';
import CustomerRemoveRequest from '../../customers/i-service/model/request/CustomerRemoveRequest';
import CustomerFileAddRequest from '../../customers/i-service/model/request/file/CustomerFileAddRequest';
import CustomerFileRemoveRequest from '../../customers/i-service/model/request/file/CustomerFileRemoveRequest';
import CustomerFileGetRequest from '../../customers/i-service/model/request/file/CustomerFileGetRequest';
import WsResponseModelT from '../../schema-builder-server/models/WsResponseModelT';
import CustomerResponse from '../../customers/i-service/model/response/CustomerResponse';
import CustomerSearchResponse from '../../customers/i-service/model/response/CustomerSearchResponse';
import CustomerContactResponse from '../../customers/i-service/model/response/CustomerContactResponse';
import CustomerInfoResponse from '../../customers/i-service/model/response/CustomerInfoResponse';
import FilePageResponse from '../../files/interfaces/models/response/FilePageResponse';

export default class CustomerService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	CreateEvent = new Events<WsResponseModelT<CustomerResponse>>();
	EditMainEvent = new Events<WsResponseModelT<Boolean>>();
	EditContactEvent = new Events<WsResponseModelT<Boolean>>();
	SearchEvent = new Events<WsResponseModelT<CustomerSearchResponse>>();
	GetContactIdEvent = new Events<WsResponseModelT<CustomerContactResponse>>();
	GetInfoEvent = new Events<WsResponseModelT<CustomerInfoResponse>>();
	CustomerRemoveEvent = new Events<WsResponseModelT<Boolean>>();
	CustomerFileAddEvent = new Events<WsResponseModelT<Boolean>>();
	CustomerFileRemoveEvent = new Events<WsResponseModelT<Boolean>>();
	CustomerFileGetEvent = new Events<WsResponseModelT<FilePageResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('CustomerService', 'Create', 'Main', (res: WsResponseModelT<CustomerResponse>) => {
			self.CreateEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'EditMain', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditMainEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'EditContact', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.EditContactEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'Search', 'Main', (res: WsResponseModelT<CustomerSearchResponse>) => {
			self.SearchEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'GetContactId', 'Main', (res: WsResponseModelT<CustomerContactResponse>) => {
			self.GetContactIdEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'GetInfo', 'Main', (res: WsResponseModelT<CustomerInfoResponse>) => {
			self.GetInfoEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'CustomerRemove', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.CustomerRemoveEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'CustomerFileAdd', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.CustomerFileAddEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'CustomerFileRemove', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.CustomerFileRemoveEvent.trigger(res);
		});
		webApiService.on('CustomerService', 'CustomerFileGet', 'Main', (res: WsResponseModelT<FilePageResponse>) => {
			self.CustomerFileGetEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Добавить
	 */
	async Create(query: CustomerCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'Create',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * изменить
	 */
	async EditMain(query: CustomerEditRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'EditMain',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменить контакты
	 */
	async EditContact(query: CustomerEditContactRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'EditContact',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * поиск
	 */
	async Search(query: CustomerSearchRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'Search',
			Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Возврашяет контакты пользователя по Id
	 */
	async GetContactId(queru: CustomerContactRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'GetContactId',
			Value: typeof(queru) === 'object' ? JSON.stringify(queru) : queru,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить информацыю о заказчике
	 */
	async GetInfo(request: CustomerContactRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'GetInfo',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async CustomerRemove(request: CustomerRemoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'CustomerRemove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить фаил
	 */
	async CustomerFileAdd(request: CustomerFileAddRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'CustomerFileAdd',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить фаил
	 */
	async CustomerFileRemove(request: CustomerFileRemoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'CustomerFileRemove',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список файлов
	 */
	async CustomerFileGet(request: CustomerFileGetRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'CustomerService',
			Method: 'CustomerFileGet',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Добавить
	 */
	async createAsync(query: CustomerCreateRequest): Promise<CustomerResponse> {
		return new Promise<CustomerResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'Create',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<CustomerResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CustomerResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * изменить
	 */
	async editMainAsync(query: CustomerEditRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'EditMain',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменить контакты
	 */
	async editContactAsync(query: CustomerEditContactRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'EditContact',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * поиск
	 */
	async searchAsync(query: CustomerSearchRequest): Promise<CustomerSearchResponse> {
		return new Promise<CustomerSearchResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'Search',
				Value: typeof(query) === 'object' ? JSON.stringify(query) : query,
				Callback: (response: WsResponseModelT<CustomerSearchResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CustomerSearchResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Возврашяет контакты пользователя по Id
	 */
	async getContactIdAsync(queru: CustomerContactRequest): Promise<CustomerContactResponse> {
		return new Promise<CustomerContactResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'GetContactId',
				Value: typeof(queru) === 'object' ? JSON.stringify(queru) : queru,
				Callback: (response: WsResponseModelT<CustomerContactResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CustomerContactResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить информацыю о заказчике
	 */
	async getInfoAsync(request: CustomerContactRequest): Promise<CustomerInfoResponse> {
		return new Promise<CustomerInfoResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'GetInfo',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<CustomerInfoResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CustomerInfoResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async customerRemoveAsync(request: CustomerRemoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'CustomerRemove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить фаил
	 */
	async customerFileAddAsync(request: CustomerFileAddRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'CustomerFileAdd',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить фаил
	 */
	async customerFileRemoveAsync(request: CustomerFileRemoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'CustomerFileRemove',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список файлов
	 */
	async customerFileGetAsync(request: CustomerFileGetRequest): Promise<FilePageResponse> {
		return new Promise<FilePageResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'CustomerService',
				Method: 'CustomerFileGet',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<FilePageResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as FilePageResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}